import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from "@angular/forms";
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { Address } from 'src/app/models/Address';
import { InfoUser } from 'src/app/models/InfoUser';
import { UserService } from 'src/app/services/user.service';
import { CONSTANTES, getToken } from 'src/app/shared/global';
declare var jQuery: any;

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss']
})
export class MyAccountComponent implements OnInit {
  public form: FormGroup;
  public nid: string;
  public firstName: string;
  public lastName: string;
  public phone: string;
  public email: string;
  public address: string;
  public userInfo : InfoUser;
  public listaAddresses: Address[] = [];
  public addresses = new FormArray([]);
  

  constructor(private userService: UserService,private spinner: NgxSpinnerService,
    private router: Router, private toastr: ToastrService,private fb: FormBuilder) {}
  
  ngOnInit() {
    
    this.createForm();
    //this.addAddress();

    jQuery.getScript(CONSTANTES.menu);
    
    this.nid = localStorage.getItem("nid");   
    this.firstName = localStorage.getItem("firstName");
    this.lastName = localStorage.getItem("lastName");
    this.phone = localStorage.getItem("phone");
    this.email = localStorage.getItem("email");
  
    if(localStorage.getItem("addresses") != null){
      let ad: Address[] = JSON.parse(localStorage.getItem("addresses"));
      for(let i = 0; i < ad.length; i++){
        if(ad[i].addressName !=null || ad[i].addressName == ''){
          let formGroup = new FormGroup({
            addressName: new FormControl(ad[i].addressName),
            postalCode: new FormControl(ad[i].postalCode),
            province: new FormControl(ad[i].province)
          });
          this.addresses.push(formGroup);
        } 
      }

/*       for (let i = 0; i < this.addresses.length; i++){
        console.log(this.addresses.controls[i].get('addressName').value);
      } */
    }

  }

  saveUserInfo() {

    this.listaAddresses = []
    for(let i = 0; i < this.addresses.controls.length; i++){
      let ad = new Address();
      ad.id = null;
      ad.addressName = this.addresses.controls[i].get('addressName').value;
      ad.postalCode = this.addresses.controls[i].get('postalCode').value;
      ad.province = this.addresses.controls[i].get('province').value;
      if(ad.addressName !=null || ad.addressName == ''){
        this.listaAddresses.push(ad);
      } 
    }

    let userInfo = {
      firstName : this.firstName,
      lastName : this.lastName,
      phone : this.phone,
      email : this.email,
      nid : this.nid,
      addresses:  this.listaAddresses     
    }

   this.userService.changeUserInfo(userInfo).subscribe(
      data => {
        if (getToken(data)) {
          this.toastr.success("SE HA ACTUALIZADO LA INFORMACIÓN CORRECTAMENTE", "INFO");
          localStorage.setItem("firstName",data.firstName);
          localStorage.setItem("lastName",data.lastName);
          localStorage.setItem("phone",data.phone);
          localStorage.setItem("email",data.email);
          localStorage.removeItem("addresses");
          if(data.addresses!=null){
            this.listaAddresses = [];
            for (let i = 0; i < data.addresses.length; i++) {
              this.listaAddresses.push(data.addresses[i]);
            }
            
            localStorage.setItem("addresses",JSON.stringify(this.listaAddresses));
          }else{
            localStorage.setItem("addresses",JSON.stringify(this.listaAddresses));
          }
          this.spinner.hide();
          this.form.reset();
          this.router.navigate(['home']);
        } else {
          this.toastr.error("SE HA PRODUCIDO UN PROBLEMA AL GUARDAR LOS DATOS", "ERROR");
          this.spinner.hide();
        }
      },
      error => {
        this.toastr.error("SE HA PRODUCIDO UN PROBLEMA AL GUARDAR LOS DATOS", "ERROR");
        this.spinner.hide();
      }
    )
  }

  deleteAddresses(indice: number) {
    this.addresses.removeAt(indice);
  }

  addAddress() {
    this.addresses.push(new FormGroup({
      addressName: new FormControl(''),
      postalCode: new FormControl(''),
      province: new FormControl('')
    }));
  }

  createForm() {
    this.form = this.fb.group({
     address: this.fb.array([])
    });
   }

}
